export default "__VITE_ASSET__AcYKplOh__"